import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { utils, write } from "xlsx";
import moment from "moment";
import Papa from "papaparse";
import { Menu } from 'primereact/menu';

import { DropDownField, TextInputField, MultiSelectField, CheckboxField, AutoCompleteField} from "../../../helpers";
import Button from "../../../helpers/Button";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchVendorPaymentsNonCredit,  updateSearchOptions, updateSearchParams, setSearchConfig, setIsSearchByLocked } from "../../../services/redux/reducers/vendorPaymentNonCredit/vendorPymentNonCredit";
import { searchVendorPayments } from "../../../services/api/vendorPayment";
import { fetchBuyerCompanies } from "../../../services/redux/reducers/commonThunk";

import { addDaysToDate, getAddFilterOptions, getAutoSearchSuggestions, getDateRange, getMatchedRegexPattern, getPMUserNameByUserId, normalizeLabel, useFuzzSearch } from "../../../utils";
import DateFilter from "../../../common/DateFilter";

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";


const vpCreditNonCreditConfig = [
    {
        srNO: 1,
        static: true,
        type: "SELECT",
        name: "dataType",
        label: "Data type",
        options: [
            { label: 'Vendor Payments Data', value: 'vendorPaymentsData' }
        ]
    },
    {   srNO: 2,
        static: true,
        type: "SEARCH_TEXT",
        name: "searchText",
        label: "Search Text",
    },
    // {
    //     srNO: 2,
    //     static: true,
    //     type: "SEARCH_BY",
    //     name: "searchBy",
    //     label: "Search by",
    //     options: [
    //         { label: 'No Filters', value: 'all' },
    //         { label: 'Vendor Payment No.', value: 'vendorPaymentDocNo' },
    //         { label: 'Seller PO No.', value: 'sellerPODocNo' },
    //         { label: 'seller PI No', value: 'sellerPINumber' },
    //         { label: 'seller PI Doc No.', value: 'sellerPIDocNo' },
    //         { label: 'Amount', value: 'amount' },
    //         { label: 'Company Name', value: 'companyName' },
    //         { label: 'User Name', value: 'userName' },
    //     ]
    // },
    {
        srNO: 3,
        static: false,
        type: "MULTISELECT",
        name: "pmBranchIds",
        label: "PM Branch"
    },
    {
        srNO: 5,
        static: false,
        type: "MULTISELECT",
        name: "paymentMode",
        label: "Payment Mode",
        options: [
            { label: 'ONLINE', value: 'ONLINE' },
            { label: 'CASH', value: 'CASH' },
            { label: 'CREDIT', value: 'CREDIT' },
            { label: 'BANK TRANSFER', value: 'BANK TRANSFER' }
        ]
    },
    {
        srNO: 6,
        static: false,
        type: "DATE",
        name: "dateType",
        label: "Date",
        options: [
            { label: 'Created Date', value: 'createdAt' },
            { label: 'Payment Date', value: 'paymentDate' },
            { label: 'Approved Date', value: 'approvedDate' }
        ]
    },
    {
        srNO: 7,
        static: false,
        type: "SELECT",
        name: "statusId",
        label: "Status",
        options: [
            { label: 'PAID', value: 10 },
            { label: 'NOT PAID', value: 9 },
            { label: 'REJECTED', value: 11 },
            { label: 'CANCELLED', value: 6 }
        ]
    },
    {
        srNO: 10,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "vendorPaymentDocNo",
        label:"Vendor Payment No.",
    },
    {
        srNO: 12,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "sellerPODocNo",
        label:"Seller PO No.",
    },
    {
        srNO: 13,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "sellerPINumber",
        label:"Seller PI No.",
    },
    {
        srNO: 14,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "sellerPIDocNo",
        label:"seller PI Doc No.",
    },
    {
        srNO: 15,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "amount",
        label:"Amount",
    },
    {
        srNO: 16,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "userName",
        label:"User Name",
        priority: 2
    },
    {
        srNO: 17,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "companyName",
        label:"Company Name",
        priority: 1
    },
    {
        srNO: 18,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "docNo",
        label: "Doc No",
    }
]

const docNoSearchLabels = ["vendorPaymentDocNo", "sellerPODocNo", "sellerPINumber", "sellerPIDocNo", "docNo"]


const Search = (props) => {
    const { selectedVendorPayments, expenseCategories } = props

    const [suggestions, setSuggestions] = useState([])

    const isLoading = useSelector(state => state.vendorPaymentsNonCredit.loading)
    const usersData = useSelector(state => state.userDetails)
    const searchParams = useSelector(state => state.vendorPaymentsNonCredit.searchParams)
    const paginationParams = useSelector(state => state.vendorPaymentsNonCredit.paginationParams)
    const searchOptions = useSelector(state => state.vendorPaymentsNonCredit.searchOptions)
    const companyBranches = usersData?.PMCompanyDetails?.companyBranches
    const isSearchByLocked = useSelector(state => state.vendorPaymentsNonCredit.isSearchByLocked)

    const filterMenu = useRef(null)
    const downloadMenu = useRef(null)
    const searchTextRef = useRef(null)

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
    const { isIndonesiaVPDownload } = pmCompanyConfig

    const searchConfig = vpCreditNonCreditConfig

    let buyerCompanies = useSelector(state => state.common.buyerCompanies)

    buyerCompanies = buyerCompanies.map(company => {
        const companyName = company.companyName 
        return {...company, displayName: companyName}
    })

    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(setSearchConfig(vpCreditNonCreditConfig))
        dispatch(fetchBuyerCompanies())

        if(searchOptions.length === 0){
            const filteredSearchOptions = searchConfig.filter(eachOption => eachOption.static)
            dispatch(updateSearchOptions(filteredSearchOptions))
        }
    }, [])

    useEffect(() => {
        if (searchTextRef.current) {
            searchTextRef.current.focus()
        }

        if (['userName', 'companyName'].includes(searchParams.searchBy)) {
            autoCompleteSearch(searchParams.searchBy, searchParams.searchText)
        }
    }, [searchParams.searchBy])

    const companyFuzzSearch = useFuzzSearch(buyerCompanies, "displayName")
    
    const addFilterOption = (srNO) => {
        let relatedConfig = searchConfig.find(eachConfig => eachConfig.srNO === srNO)
        relatedConfig = {...relatedConfig}
        if(relatedConfig.name === "pmBranchIds"){
            const updatedCompanyBranches = companyBranches?.map(eachCompanyBranch => ({...eachCompanyBranch, label:eachCompanyBranch.branchName, value:eachCompanyBranch.branchId}))
            relatedConfig.options = updatedCompanyBranches
        }
        dispatch(updateSearchOptions([...searchOptions, relatedConfig]))
    }

    const removeFilterOption = (srNO) => {
        const relatedSearchOption = searchOptions.find(eachOption => eachOption.srNO === srNO)
        const updatedSearchParams = {...searchParams}

        if(relatedSearchOption.type === "SEARCH_BY"){
            updatedSearchParams.searchText = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "DATE"){
            updatedSearchParams.fromDate = null
            updatedSearchParams.toDate = null
            updatedSearchParams.range = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "SELECT"){
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "TEXT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "MULTISELECT"){
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }

        const filteredSearchOptions = searchOptions.filter(eachOption => eachOption.srNO !== srNO)
        dispatch(updateSearchOptions([...filteredSearchOptions]))
    }

    const handleSearchOnChange = (event) => {
        let eventValue = event.target.value

        if(eventValue && (eventValue.userId || eventValue.companyId)){
            eventValue = eventValue.displayName
        }

        const updatedSearchParams = {...searchParams, [event.target.name]: eventValue}

        if (eventValue instanceof Date) {
            if(new Date(searchParams[event.target.name])?.getTime() != eventValue.getTime()){
                updatedSearchParams.range = null
            }

            if (event.target.name === "toDate") {
                eventValue.setHours(23, 59, 0, 0)
            }
            if (event.target.name === "fromDate") {
                eventValue.setHours(0, 0, 0, 0)
            }
            eventValue = eventValue.toISOString()

            updatedSearchParams[event.target.name] = eventValue
        }

        if(event.target.name === "searchText" && event.target.value.length > 3){
            const availableOptions = [...vpCreditNonCreditConfig]
            const matchText = eventValue.split(";")[0]
            const matchedPattern = getMatchedRegexPattern(matchText, availableOptions, searchParams.searchBy)
            if (event.target.name === "searchBy"){
                dispatch(setIsSearchByLocked(true))
            }
        }

        if (event.target.name === "searchBy"){
            dispatch(setIsSearchByLocked(true))
        }

        dispatch(updateSearchParams(updatedSearchParams))
    }

    const handleSearchByLock = () => {
        if(isSearchByLocked && searchParams.searchText === ""){
            const updatedSearchParams = { ...searchParams, searchBy : "all" }
            dispatch(updateSearchParams(updatedSearchParams))
        }
        else if(isSearchByLocked && searchParams.searchText !== ""){
            const availableOptions = [...vpCreditNonCreditConfig]
            const matchedPattern = getMatchedRegexPattern(searchParams.searchText, availableOptions, searchParams.searchBy)
            const updatedSearchParams = { ...searchParams, searchBy : matchedPattern }
            dispatch(updateSearchParams(updatedSearchParams))
        }
        dispatch(setIsSearchByLocked(!isSearchByLocked))
    }

    const handleDateRangeChange = (range) => {
        const { fromDate, toDate } = getDateRange(range)

        dispatch(updateSearchParams({ ...searchParams, range, fromDate, toDate }))
    }

    const autoCompleteSearch = (searchType, query) => {        
        const suggestions = getAutoSearchSuggestions({
            searchType,
            query,
            buyerCompanies,
            companyFuzzSearch
        })
        
        setSuggestions(suggestions)
    }

    const handleCheckboxSelect = (event) => {
        const updatedSearchParams = {...searchParams, [event.target.name]: event.target.checked}
        dispatch(updateSearchParams(updatedSearchParams))
    }

    const addFilterOptions = getAddFilterOptions(searchConfig, searchOptions, searchParams, addFilterOption)

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    } 

    const handleSearch = () => {
        let errorFound = false

        if (searchParams.searchText === "" && searchParams.searchBy !== "all") {
            dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: "Please enter search text" }))
            errorFound = true
        } 
        else if (searchParams.searchText && searchParams.searchBy !== "all"){
            const relatedSearchOption = searchConfig.find(eachOption => eachOption.name === searchParams.searchBy)
            if(relatedSearchOption.isValid && !relatedSearchOption.isValid(searchParams.searchText.split(";")[0])){
                dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: `Please enter valid ${normalizeLabel(searchParams.searchBy).toLowerCase()}` }))
                errorFound = true
            }
        }
        
        searchOptions.map(eachOption => { 
            if (["TEXT", "SELECT", "AUTO_COMPLETE"].includes(eachOption.type)) {
                if (!searchParams[eachOption.name] && searchParams[eachOption.name] !== false) {
                    const errorMsgText = normalizeLabel(eachOption.label)
    
                    dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter ${errorMsgText.toLowerCase()}` }))
                    errorFound = true
                } else {
                    if(eachOption.isValid && !eachOption.isValid(searchParams[eachOption.name].split(";")[0])){
                        const errorMsgText = normalizeLabel(eachOption.label)
                        dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter valid ${errorMsgText.toLowerCase()}` }))
                        errorFound = true
                    }
                }
            } 
        })

        const updatedSearchParams = {...searchParams}

        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }

        const vendorPaymentSearchParams = {
            ...paginationParams,
            ...updatedSearchParams,
            pageNo: 0,
            paginator: true
        }

        if(!vendorPaymentSearchParams.paymentMode?.length){
            vendorPaymentSearchParams.paymentMode = ["CASH", "BANK TRANSFER", "ONLINE", "CREDIT"]
        }
        if(!searchParams.statusId){
            vendorPaymentSearchParams.statusIds = [9, 10, 11, 6]
        } else {
            vendorPaymentSearchParams.statusIds = [searchParams.statusId]
        }

        if(searchParams.dateType === "paymentDate"){
            vendorPaymentSearchParams.sortBy = "paymentDate"
        }

        if(searchParams.bookedFlag && !searchParams.toDate){
            return dispatch(raiseToast({severity:'error', detail: "Please select date range" , life: 3000}))
        }
        
        if(!errorFound){
            dispatch(fetchVendorPaymentsNonCredit(vendorPaymentSearchParams))
        }
    }

    const downloadFormatOptions = [
        {
            label: "XLSX",
            command: () => downloadVPDataForVendorPayment("XLSX")
        },
        {
            label: "CSV",
            command: () => downloadVPDataForVendorPayment("CSV")
        }
    ]

    const downloadVPDataForVendorPayment = async (dataFormat) => {
        const selectedVendorPaymentIds = selectedVendorPayments.map(eachVendorPayment => eachVendorPayment.vendorPaymentId)

        if(!selectedVendorPaymentIds.length){
            return dispatch(raiseToast({severity:'error', detail: "Please select vendor payments"}))
        }

        const vendorPaymentSearchParams = {
            requiredBankDetails: true,
            requiredSellerPOApprovals: true,
            requireAlrets: true,
            searchBy: "all",
            searchText: "",
            dateType: "createdAt",
            vendorPaymentIds: selectedVendorPaymentIds,
            statusIds: [9],
            paginator: false,
            paymentMode: ["CASH", "BANK TRANSFER", "ONLINE", "CREDIT"]
        }

        const vendorPaymentResponse = await searchVendorPayments(vendorPaymentSearchParams)
        
        if(vendorPaymentResponse.failure){
            dispatch(raiseToast({severity:'error',detail: vendorPaymentResponse.data.error}))
        } else {
            const vendorPaymentsNonCreditData = vendorPaymentResponse.data.data
            const companyBankAccounts = vendorPaymentResponse.data.companyBankAccounts
            const sellerPIPunches = vendorPaymentResponse.data.sellerPIPunches
            const sellerPOItemsWithVendorPaymentButGRNNotDone = vendorPaymentResponse.data.sellerPOItemsWithVendorPaymentButGRNNotDone
            const sellerPOApprovals = vendorPaymentResponse.data.sellerPOApprovals

            const invalidGSTINSExist = vendorPaymentsNonCreditData.some(eachVendorPayment => eachVendorPayment["sellerGSTIN.statusId"] != 1)

            if(invalidGSTINSExist){
                dispatch(raiseToast({severity:'error', detail: "Warning: Payments with invalid gstins found on downloaded data. please check before proceeding with payment" , life: 20000}))
            }

            const downloadData = []
            vendorPaymentsNonCreditData.map(eachVendorPayment => {
                let remarks = ""
                let bankAccountDeletedRemarks = ""
                let relatedBankDetails = null
                let obj = {}
                if(eachVendorPayment["sellerPO.prefBankAccountId"]){
                    relatedBankDetails = companyBankAccounts.find(eachBankAccount => eachBankAccount.bankAccId === eachVendorPayment["sellerPO.prefBankAccountId"])
                    if (!relatedBankDetails) {
                        const branchRelatedBankDetails = companyBankAccounts.filter(eachBankAccount => eachBankAccount.branchId.includes(eachVendorPayment.branchId))
                        if(branchRelatedBankDetails.length === 1){
                            relatedBankDetails = branchRelatedBankDetails[0]
                        } else {
                            bankAccountDeletedRemarks = "Selected bank account is deleted."
                        }
                    }
                }else{
                    relatedBankDetails = companyBankAccounts.find(eachBankAccount => eachBankAccount.branchId.includes(eachVendorPayment.branchId))
                }
                
                if(isIndonesiaVPDownload){
                    obj = {
                        "Payment Amount (21X)": eachVendorPayment.amount,
                        "Transaction Reference Number (15X)": eachVendorPayment.docNo,
                        "Beneficiary Name (35X)": relatedBankDetails.holderName,
                        "Beneficiary Account Number (35X)": relatedBankDetails.accNo,
                        "Beneficiary Bank Name (35X))": relatedBankDetails.bankName,
                        "Beneficiary Bank SWIFT Code (11X)****" : relatedBankDetails.ifscCode,
                    }
                }
                else{
                    const relatedPMBranch = companyBranches.find(eachBranch => eachBranch.branchId === eachVendorPayment.pmBranchId)
                    const relatedSellerPIPunch = sellerPIPunches.find(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchId === eachVendorPayment.sellerPIPunchId)
                    
                    const ifscChars = (relatedBankDetails?.ifscCode.slice(0, 4))?.toUpperCase()
                    let paymode = "N"
                    if(ifscChars == "ICIC"){
                        paymode = "I"
                    }

                    let sellerName = ""
                    if(eachVendorPayment["sellerPO.seller.firstName"]){
                        sellerName = eachVendorPayment["sellerPO.seller.firstName"]
                    }
                    if(eachVendorPayment["sellerPO.seller.lastName"]){
                        sellerName = eachVendorPayment["sellerPO.seller.lastName"]
                    }

                    let approvedByUser = ""
                    if(eachVendorPayment["approvedVendorUsers.firstName"]){
                        approvedByUser += eachVendorPayment["approvedVendorUsers.firstName"]
                    }
                    if(eachVendorPayment["approvedVendorUsers.lastName"]){
                        approvedByUser += " " + eachVendorPayment["approvedVendorUsers.lastName"]
                    }

                    let relatedSellerPOAmountApprover = sellerPOApprovals.find(eachSellerPOApproval => eachSellerPOApproval["sellerPODocNo"] === eachVendorPayment["sellerPO.docNo"])
                    
                    if(relatedSellerPOAmountApprover && eachVendorPayment["approvedOrRejectedBy"] === 18766){
                        approvedByUser = relatedSellerPOAmountApprover.processedByName
                    }

                    if(true){
                        remarks += eachVendorPayment.docNo + " - " + relatedPMBranch?.branchName + " - " + approvedByUser
                    }

                    if(true){
                        remarks += " " + " - "
                        if(relatedSellerPIPunch?.sellerPINumber){
                            remarks += relatedSellerPIPunch?.sellerPINumber + " - "
                        }
                        remarks +=  eachVendorPayment.amount + " - " + eachVendorPayment["sellerPO.companies.companyName"]
                    }

                    if(eachVendorPayment?.paymentMode){
                        remarks += " - " + eachVendorPayment.paymentMode
                    }

                    if(relatedPMBranch?.branchName){
                        const voucherType = `Payments ${relatedPMBranch?.branchName}`

                        remarks += " - " + voucherType
                    }

                    if(eachVendorPayment["sellerPO.expenseCategoryId"]){
                        const relatedExpenseCategory = expenseCategories.find(eachCategory => eachCategory.expenseCategoryId === eachVendorPayment["sellerPO.expenseCategoryId"])
                        remarks += ` - EXPENSE-${relatedExpenseCategory?.expenseCategoryName}`
                    }

                    let Note = ''
                    if (eachVendorPayment["sellerPO.docNo"]) {
                        const relatedSellerPOItemsWithVendorPaymentButGRNNotDone = sellerPOItemsWithVendorPaymentButGRNNotDone.filter(eachPOItem => eachPOItem.docNo !== eachVendorPayment['sellerPO.docNo'] && eachPOItem.companyId === eachVendorPayment['sellerPO.companyId'])
                        const kamName = getPMUserNameByUserId(usersData?.PMCompanyDetails?.companyUsers, relatedSellerPOItemsWithVendorPaymentButGRNNotDone[0]?.createdBy)

                        const relatedSellerPOItemsWithDeliveryPending = relatedSellerPOItemsWithVendorPaymentButGRNNotDone.filter(eachPOItem => {
                            const deliveryDate = addDaysToDate(eachPOItem.createdAt, eachPOItem.leadTime)
                            const modifiedDeliveryDate = new Date(deliveryDate)
                            const diff = modifiedDeliveryDate < new Date()

                            return diff
                        })

                        if (relatedSellerPOItemsWithDeliveryPending.length) {
                            const materialIds = relatedSellerPOItemsWithDeliveryPending.map(eachPOItem => eachPOItem.materialId)
                            const deliveryDelaytext = `Materials with advance vendor payment was done but delivery delayed: ${materialIds.join(', ')}; `
                            Note = Note + deliveryDelaytext
                        }

                        if (relatedSellerPOItemsWithVendorPaymentButGRNNotDone.length) {
                            const materialIds = relatedSellerPOItemsWithVendorPaymentButGRNNotDone.map(eachPOItem => eachPOItem.materialId)
                            let materialsNotRecived = `Materials with advance vendor payment was done but not recieved yet: ${materialIds.join(', ')}; `
                            materialsNotRecived = materialsNotRecived + `seller PO Doc No: ${relatedSellerPOItemsWithVendorPaymentButGRNNotDone[0]['docNo']}; KAM: ${kamName}`
                            Note = Note + materialsNotRecived
                        }
                    }

                    obj = {
                        "Debit Ac No" : "'007305015788",
                        "Beneficiary Ac No" : bankAccountDeletedRemarks || "'" + relatedBankDetails?.accNo,
                        "Beneficiary Name" : eachVendorPayment["sellerPO.companies.companyName"],
                        "Amt" : eachVendorPayment["amount"],
                        "Pay Mod" : paymode,
                        "Date" : "'" + moment().format("DD-MMM-YYYY"),
                        "IFSC" : relatedBankDetails?.ifscCode ? relatedBankDetails?.ifscCode : "",
                        //"Payment Mode": eachVendorPayment?.paymentMode,
                        //"Voucher Type": voucherType,
                        "Payable Location" : "",
                        "Print Location" : "",
                        "Bene Mobile No." : eachVendorPayment["sellerPO.seller.phoneNumber"],
                        "Bene Email ID" : eachVendorPayment["sellerPO.seller.emailId"],
                        "Bene add1" : '',
                        "Bene add2" : '',
                        "Bene add3" : '',
                        "Bene add4" : '',
                        "Add Details 1" : '',
                        "Add Details 2" : '',
                        "Add Details 3" : '',
                        "Add Details 4" : '',
                        "Add Details 5" : '',
                        "Remarks" : remarks,
                        "Note" : Note
                    }
                }
                downloadData.push(obj)
            })

            if(dataFormat === "CSV"){
                let csv = Papa.unparse(downloadData, { download: true })
                let blob = new Blob([csv])
                let a = window.document.createElement("a")
                a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
                a.download = "VP_bankdetails.csv"
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
            if(dataFormat === "XLSX"){
                const ws = utils.json_to_sheet(downloadData)

                const range = utils.decode_range(ws['!ref']);
                for (let R = range.s.r; R <= range.e.r; ++R) {
                    for (let C = range.s.c; C <= range.e.c; ++C) {
                        const cellAddress = utils.encode_cell({ r: R, c: C });
                        if (ws[cellAddress] && ws[cellAddress].t === 's' && ws[cellAddress].v.charAt(0) === "'") {
                            ws[cellAddress].v = ws[cellAddress].v.substring(1);
                        }
                    }
                }

                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Sheet1')
                const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'VP_bankdetails.xlsx'
                a.click()
                URL.revokeObjectURL(url)
            }
        }
    }

    let isDocNoSearch = false 
    if(docNoSearchLabels.includes(searchParams.searchBy) && searchParams.searchText !== ""){
        isDocNoSearch = true
    }
    const searchKeys = Object.keys(searchParams)
    if(searchKeys.some(eachKey => docNoSearchLabels.includes(eachKey) && searchParams[eachKey] !== "")){
        isDocNoSearch = true
    }
    return (
        <div className="p-card" style={{border:"1px solid #e9ecef"}} onKeyDown={handleSearchKeyPress}>
            <div className="grid"> 
                {
                    searchOptions.map(eachOption => {
                        if (eachOption.type === "SEARCH_TEXT") {

                            let searchByOptions = [{label: '', value: 'all'}]
                            searchConfig.map(eachSearchBy => {
                                if (eachSearchBy.isSearchByOption) {
                                    const optionInUse = searchOptions.find(eachSearchOption => eachSearchOption.srNO === eachSearchBy.srNO)
                                    if(!optionInUse){
                                        searchByOptions.push({ label: eachSearchBy.label, value: eachSearchBy.name })
                                    }
                                }
                            })
    
                            return (
                                <>
                                    <div className="flex flex-column col-12">
                                        {['userName'].includes(searchParams.searchBy) ? (
                                            <AutoCompleteField
                                                value={searchParams.searchText}
                                                suggestions={suggestions}
                                                searchMethod={(e) => autoCompleteSearch(searchParams.searchBy, e.query)}
                                                field="displayName"
                                                labelText="Search Text"
                                                onChange={handleSearchOnChange}
                                                name="searchText"
                                                dropdown
                                                refName={searchTextRef}
                                            />
                                        ) : (
                                            <TextInputField
                                                name="searchText"
                                                labelText="Search Text"
                                                placeholder="No Filter"
                                                refName={searchTextRef}
                                                value={searchParams["searchText"]}
                                                onChange={handleSearchOnChange}
                                            />
                                        )}
                                    </div>
                                    {(searchParams.searchText || isSearchByLocked)  && (
                                        <>
                                            <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i
                                                className={`pi ${isSearchByLocked ? 'pi-lock' : 'pi-lock-open'}`}
                                                style={{ position: 'absolute', top: '6px', cursor: 'pointer', color: 'orange' }}
                                                onClick={() => handleSearchByLock()}
                                            ></i>
                                            </div>
                                            <div className="flex flex-column col-12">
                                            <DropDownField
                                                name="searchBy"
                                                labelText="Search By"
                                                options={searchByOptions}
                                                value={searchParams["searchBy"]}
                                                onChange={handleSearchOnChange}
                                            />
                                            </div>
                                        </>
                                    )}
                                </>
                            )
                        }

                        if(eachOption.type === "DATE"){
                            return (
                                <>
                                    <DateFilter 
                                        disabled={isDocNoSearch}
                                        eachOption={eachOption} 
                                        searchParams={searchParams} 
                                        dateOptions={["MTD", "PM", "L15", "L30"]}
                                        handleDateRangeChange={handleDateRangeChange} 
                                        handleSearchOnChange={handleSearchOnChange}
                                        removeFilterOption={removeFilterOption}
                                    />
                                </>
                            )
                        }

                        if (eachOption.type === "SELECT") {
                            const updatedOptions = eachOption.options.map(eachSelectOption => ({ label: eachSelectOption.label, value: eachSelectOption.value }))
                            return (
                                <>
                                    {!eachOption.static ?
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null
                                    }
                                    <div className="flex flex-column col-12">
                                        <DropDownField name={eachOption.name} options={updatedOptions} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                    </div>
                                </>
                            )
                        }

                        if (eachOption.type === "TEXT") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12">
                                            <TextInputField name={eachOption.name} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                        </div>
                                    }
                                </>
                            )
                        }
    
                        if (eachOption.type === "AUTO_COMPLETE") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12">
                                            <AutoCompleteField
                                                value={searchParams[eachOption.name]}
                                                suggestions={suggestions}
                                                searchMethod={(e) => autoCompleteSearch(eachOption.name, e.query)}
                                                field="displayName"
                                                labelText={eachOption.label}
                                                onChange={handleSearchOnChange}
                                                name={eachOption.name}
                                                dropdown
                                            />
                                        </div>
                                    }
                            </>)
                        }

                        if(eachOption.type === "MULTISELECT"){
                            return (
                                <>  
                                    { !eachOption.static ? 
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={()=> removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null 
                                    }
                                    <div className="flex flex-column col-12 custom-multiselect">
                                        <MultiSelectField name={eachOption.name} labelText={eachOption.label} options={eachOption.options} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                    </div>
                                </>
                            )
                        }
                    })
                }

                <div className="flex flex-column col-12">
                    <div className="flex flex-row justify-content-between">
                        <CheckboxField name="bookedFlag" onChange={handleCheckboxSelect} checked={isDocNoSearch ? false : searchParams.bookedFlag} disabled={isDocNoSearch} label="Booked" />
                        <CheckboxField name="openIssues" onChange={handleCheckboxSelect} checked={isDocNoSearch ? false : searchParams.openIssues} disabled={isDocNoSearch} label="Open Issues" />
                    </div>
                </div>

                <div className="flex flex-column col-12">
                    <label style={{ fontSize: "12px", marginBottom: "5px" }}>Vendor Type:</label>
                    <div className="flex flex-row justify-content-between mb-1">
                        <CheckboxField name="isAmazonVendor" onChange={handleCheckboxSelect} checked={isDocNoSearch ? false : searchParams.isAmazonVendor} disabled={isDocNoSearch} label="Amazon Vendor" />
                    </div>
                    <div className="flex flex-row justify-content-between mb-1">
                        <CheckboxField name="isBriquettes" onChange={handleCheckboxSelect} checked={isDocNoSearch ? false : searchParams.isBriquettes} disabled={isDocNoSearch} label="Briquettes" />
                    </div>
                    <div className="flex flex-row justify-content-between mb-1">
                        <CheckboxField name="otherVendors" onChange={handleCheckboxSelect} checked={isDocNoSearch ? false : searchParams.otherVendors} disabled={isDocNoSearch} label="Others" />
                    </div>
                </div>

                <div className="flex flex-column col-12">
                    <label style={{ fontSize: "12px" }}>GSTIN Status:</label>
                    <div className="mt-2"></div>
                    <CheckboxField name="displayActiveGSTINs" onChange={handleCheckboxSelect} checked={isDocNoSearch ? false : searchParams.displayActiveGSTINs} disabled={isDocNoSearch} label="Only Active GSTINs" />
                    <div className="mt-1"></div>
                    <CheckboxField name="displayInActiveGSTINs" onChange={handleCheckboxSelect} checked={isDocNoSearch ? false : searchParams.displayInActiveGSTINs} disabled={isDocNoSearch} label="Inactive/ Blacklisted/ On-hold" />
                </div>

                <div className="flex col-12 justify-content-end">
                    <Menu model={addFilterOptions} popup ref={filterMenu} />
                    <Button icon="pi pi-filter" className="h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="Add Filter" onClick={(e) => filterMenu.current.toggle(e)} />
                </div>

                <div className="flex flex-column col-12 mb-0 pb-0">
                    <div className="grid">
                        <div className="flex col-12 mb-0 gap-1 pb-0" style={{cursor : isLoading? 'not-allowed' : 'pointer'}}>
                            <Button label="Search" style={{flexGrow: 1}} className="py-2" onClick={handleSearch} disabled={isLoading}/>
                            <Menu model={downloadFormatOptions} popup ref={downloadMenu} />
                            <Button icon="pi pi-download" className="py-2 px-3"  onClick={(e) => downloadMenu.current.toggle(e)}  permissions={[245]}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Search;
